var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"weather-forecast"},[_c('h4',{staticClass:"dashboard-header"},[_vm._v(_vm._s(_vm.$t('weatherForecast')))]),_c('div',{staticClass:"weather-forecast__deck"},_vm._l((_vm.forecast),function(item){return _c('WeatherForecastCard',{key:item.date.toISOString(),attrs:{"forecast":item,"screen-size":_vm.screenSize}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }